<template lang="pug">
    Tabs.wish-list-list
        el-card.contains-table(shadow="always")
            .error(v-if="error")
                template(v-if="error.code")
                    Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
                template(v-else)
                    Error(:message="$t('Something went wrong!')" :code="501")
            .wish-lists-table(v-else)
                //- :row-link-config="wishListsPaginated.link"
                paginated-items(
                    scope="ex"
                    type="shop_wish_list"
                    :loading="loading"
                    :items="wishListsPaginated.items"
                    :filters="filters"
                    :show-filters="showFilters"
                    :variables="wishListsPaginated.variables"
                    :all-columns="wishListsPaginated.allColumns"
                    :active-columns="wishListsPaginated.activeColumns"
                    :page-info="wishListsPaginated.pageInfo"
                    :sort="sort"
                    @pagination-size-change="handleSizeChange"
                    @pagination-current-change="handleCurrentChange"
                    @show-table-columns="handleColsShow"
                    @change-filter="handleFilterInputChange"
                    @click="handleClick"
                    @change-sort="handleSortInputChange"
                )
                    template(slot="top")
                        el-row.table-top(v-loading="loading" type="flex" justify="space-between")
                            .row
                                .left
                                    //- el-button(type="primary" size="mini" icon="el-icon-fa-plus fas" @click="addWishList" :disabled="true")
                                    //-     | {{ $t('New Wish List') }}

                                    el-button(
                                        v-if="enabledExtensions.includes('shop')"
                                        plain
                                        type="primary"
                                        size="mini"
                                        icon="el-icon-fa-download fas"
                                        @click="toggleTransferForm({ key: 'csv' }, 'csv-wish-list-import')"
                                    )
                                        | {{ $t('CSV Wish List Import') }}
                                .right.hide-on-empty
                                    el-button(
                                        :type="includeGuests ? 'primary' : 'info'"
                                        size="mini"
                                        :icon="includeGuests ? 'el-icon-fa-eye far' : 'el-icon-fa-eye-slash far'"
                                        @click="toggleIncludeGuests"
                                    )
                                        | {{ $t('Guest wish lists') }}
                                    | &nbsp;
                                    el-button(
                                        plain
                                        size="mini"
                                        type="primary"
                                        icon="el-icon-fa-filter fas"
                                        @click="toggleFilterVisiblity"
                                        :disabled="disable.showFilters || hasFilters"
                                    )
                                        span(v-if="showFilters") {{ $t('Hide filters') }}
                                        span(v-else) {{ $t('Show filters') }}
                            transition(name="slide-decent-vertical")
                                .transfer(v-if="visibleTransfer")
                                    transition(name="slide-decent-vertical" mode="out-in")
                                        CsvImport(
                                            v-if="visibleTransfer.config.key === 'csv'"
                                            :key="visibleTransfer.config.key"
                                            @refresh="refetch"
                                        )
                    template(v-slot:customer_name="{ item, value }")
                        template(v-if="value")
                            span {{ value }}
                        template(v-else-if="item.session_id")
                            el-tag(size="mini" type="info") {{ $t('Guest') }}
                        template(v-else)
                            span -
                    template(v-slot:tax_total="{ item, value }")
                        span {{ value | moneyFormat(getCurrency(item)) }}
                    template(v-slot:grand_total="{ item, value }")
                        span {{ value | moneyFormat(getCurrency(item)) }}
                    template(v-slot:actions="{ item }")
                        template(v-if="copyPasteWishListsFeatureEnabled")
                            el-button.copy-button(
                                v-if="!copiedWishList"
                                circle
                                size="mini"
                                type="info"
                                icon="el-icon-fa-copy far"
                                @click.stop.prevent="toggleCopyWishList(item.id)"
                            )
                            el-button.copy-button(
                                v-else-if="parseInt(item.id) === parseInt(copiedWishList)"
                                circle
                                size="mini"
                                type="default"
                                icon="el-icon-fa-clipboard fas"
                                @click.stop.prevent="toggleCopyWishList(item.id)"
                            )
                            el-button.copy-button(
                                v-else
                                circle
                                size="mini"
                                type="primary"
                                icon="el-icon-fa-paste fas"
                                @click.stop.prevent="showWishListClipboardModal(item)"
                            )

        el-dialog.overwrite-wish-list-dialog(
            :title="$t('Copy wish list')"
            :visible.sync="wishListClipboardModal.visibility"
            :close-on-click-modal="false"
            top="10vh"
            width="520px"
            @closed="resetWishListClipboardModal"
        )
            .body(v-loading="wishListClipboardModal.loading")
                p {{ $t('Are you sure you want to overwrite this wish list?') }}
            template(slot="footer")
                el-button(
                    size="mini"
                    icon="el-icon-fa-times fas"
                    @click="wishListClipboardModal.visibility = false"
                ) {{ $t('Dismiss') }}
                el-button(
                    :loading="wishListClipboardModal.pasting"
                    size="mini"
                    type="danger"
                    icon="el-icon-fa-check fas"
                    @click="pasteWishList"
                    :disabled="wishListClipboardModal.pasting"
                ) {{ $t('Overwrite irreversible') }}
</template>

<i18n>
{
    "de": {
        "Guest": "Gast",
        "Guest wish lists": "Gast-Wunschlisten",
        "New Wish List": "Neuer Warenkorb",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Wish lists could not be fetched.": "Warenkorbliste konnte nicht abgerufen werden.",
        "Wish List could not be fetched.": "Warenkorb konnte nicht abgerufen werden.",
        "Copy wish list": "Warenkorb kopieren",
        "CSV Wish List Import": "CSV Wunschlisten-Import",
        "Are you sure you want to overwrite this wish list?": "Soll dieser Warenkorb wirklich überschrieben werden?",
        "Wish list copied successfully!": "Warenkorb wurde erfolgreich kopiert",
        "Wish list pasted successfully!": "Warenkorb wurde erfolgreich eingefügt",
        "Wish list removed from clipboard!": "Warenkorb aus dem Zwischenspeicher entfernt",
        "Overwrite irreversible": "Unwiderruflich überschreiben"
    }
}
</i18n>

<script>
import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo'

import router from '@/router'
import pinia from '@/pinia';
import { useAuthStore, useSetupStore, useShopWishListStore } from '@/stores'

import WishListApi from '@/extensions/shop/store/api/wishList';
import PaginatedItems from '@/components/PaginatedItems'
import Tabs from '@/extensions/shop/views/Partials/SalesTabs'
import Error from '@/components/Error'

import CsvImport from '@/extensions/shop/components/WishLists/WishListCsvImport';

export default {
    name: 'WishLists',
    data() {
        return {
            error: false,
            wishListClipboardModal: {
                pasting: false,
                visibility: false,
                item: undefined,
            },
            disable: {
                showFilters: false,
            },
            visibleTransfer: undefined
        }
    },
    components: {
        PaginatedItems,
        CsvImport,
        Error,
        Tabs
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true)
            if (reload) this.initialize()
        },
    },
    computed: {
        user() {
            return useAuthStore().user;
        },
        includeGuests() {
            var key = 'ex:shop_wish_list:include_guests';
            var misc = _.get(this.user, 'settings.misc') || [];
            var setting = misc.find(function (item) { return item && item.key === key; });
            var value = _.get(setting, 'value') || 'false';
            return value === 'true';
        },
        copyPasteWishListsFeatureEnabled() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return !!features.find(el => el === 'copy-paste-wish-lists');
        },
        showFilters() {
            return this.hasFilters || _.get(this.wishListsPaginated, 'showFilters') || false
        },
        hasFilters() {
            return !_.isEmpty(this.filters)
        },
        filters() {
            let filters = _.cloneDeep(this.wishListsPaginated.filters)
            delete filters.shop
            delete filters.hide_guests
            return filters
        },
        sort() {
            var variables = this.wishListsPaginated.variables;
            var defaultSort = this.wishListsPaginated.defaultSort || { field: 'id', direction: 'desc' };
            var order = (variables.order !== undefined && variables.order !== '') ? variables.order : defaultSort.field;
            var direction = (variables.direction !== undefined && variables.direction !== '') ? variables.direction : defaultSort.direction;
            return { field: order, direction: direction };
        },
        activeShop() {
            return this.activeCms.shop
        },
        copiedWishList() {
            const context = `cms:${this.activeCms.id}`
            return _.get(this.clipboard, `${context}.wish-list`);
        },
        setupStore() {
            return useSetupStore(pinia);
        },
        wishListStore() {
            return useShopWishListStore(pinia);
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions;
        },
        clipboard() {
            return this.setupStore.clipboard;
        },
        debounce() {
            return this.setupStore.debounce;
        },
        loading() {
            return this.wishListStore.loading;
        },
        wishListsPaginated() {
            return this.wishListStore.wishListsPaginated;
        }
    },
    methods: {
        toggleTransferForm(config, scope) {
            let visibleTransfer = { scope, config };

            if (
                this.visibleTransfer &&
                this.visibleTransfer.scope === scope &&
                this.visibleTransfer.config.key === config.key
            ) {
                visibleTransfer = undefined;
            }

            this.visibleTransfer = visibleTransfer;
        },
        async refreshCustomerTransfer() {
            this.disable.customerTransfer = true
            await this.refetch();
            this.disable.customerTransfer = false
        },
        toggleIncludeGuests() {
            var key = 'ex:shop_wish_list:include_guests';
            var value = !this.includeGuests;
            this.updateLoading(true);
            this.saveMiscSettings({ key, value: value.toString() })
                .then(this.refetch);
        },
        toggleCopyWishList(id) {
            if (parseInt(id) === parseInt(this.copiedWishList)) {
                this.removeFromClipboard('wish-list');

                this.$notify.warning({
                    title: this.$t('Wish list removed from clipboard!'),
                    iconClass: 'far el-icon-fa-clipboard',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 6000
                });
            } else {
                this.setClipboard({ key: 'wish-list', value: parseInt(id) });

                this.$notify.success({
                    title: this.$t('Wish list copied successfully!'),
                    iconClass: 'fas el-icon-fa-copy',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 6000
                });
            }
        },
        async pasteWishList() {
            this.wishListClipboardModal.pasting = true;
            await WishListApi.fetchWishListWithArticlePivots(this.copiedWishList, this.activeCms.shop.id)
                .then(wishList => {
                    this.wishListClipboardModal.item.articlePivots = wishList.articlePivots.map(el => {
                        return {
                            article: el.article,
                            propertyValueOptions: el.propertyValueOptions,
                            qty: el.qty
                        };
                    });
                })
                .catch(error => {
                    console.error(error);
                    this.wishListClipboardModal.pasting = false;

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Wish List could not be fetched.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                });

            if (_.get(this.wishListClipboardModal.item, 'articlePivots.length')) {
                WishListApi.save(this.wishListClipboardModal.item)
                    .then(() => {
                        this.resetWishListClipboardModal();
                        this.removeFromClipboard('wish-list');

                        this.$notify.success({
                            title: this.$t('Wish list pasted successfully!'),
                            iconClass: 'fas el-icon-fa-paste',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 6000
                        });

                        this.updateLoading(true)
                        this.refetch()
                    })
                    .catch(error => {
                        console.error(error);
                        this.wishListClipboardModal.pasting = false;

                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Wish List could not be saved.'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                    });
            }
        },
        showWishListClipboardModal(item) {
            this.wishListClipboardModal.visibility = true;
            this.wishListClipboardModal.item = item;
        },
        resetWishListClipboardModal() {
            this.wishListClipboardModal = {
                pasting: false,
                visibility: false,
                item: undefined,
            }
        },
        initialize() {
            if (!this.enabledExtensions.includes('shop')) {
                this.updateLoading(true)
                return
            }

            this.updateLoading(true)
            this.refetch()
        },
        getCurrency(item) {
            return _.get(item, 'customer.customerGroup.currency.iso4217')
                || _.get(this.activeCms, 'shop.defaultCustomerGroup.currency.iso4217')
        },
        addWishList() {
            // TODO
            // open stepper modal

            // const params = { id: 'new' }
            // router.push({ name: 'wish-list-main', params })
        },
        handleClick(item) {
            const params = { id: item.id }
            router.push({ name: 'wish-list-main', params })
        },
        handleSizeChange(itemsPerPage) {
            this.updateLoading(true)
            this.defineItemsPerPage(itemsPerPage)
            this.refetch()
        },
        handleCurrentChange(currentPage) {
            this.updateLoading(true)
            this.defineCurrentPage(currentPage)
            this.refetch()
        },
        handleColsShow(visibleColumns) {
            this.defineActiveColumns(visibleColumns)
            // apolloClient.cache.reset()
            apolloClient.clearStore()
        },
        handleFilterInputChange(key, value, debounce = true) {
            this.defineFilterValue({ key, value })
            if (debounce) this.debouncedRefetch()
            else this.refetch()
        },
        handleSortInputChange(key, value) {
            this.defineSort({ key, value });
            this.refetch();
        },
        toggleFilterVisiblity() {
            const visible = this.showFilters

            let value = false
            if (!visible) value = true

            this.disable.showFilters = true
            this.defineFilterVisibility(value)
            this.saveFilterVisibility({ scope: 'ex', key: 'shop_wish_list', value })
                .finally(() => this.disable.showFilters = false)
        },
        refetch() {

            // always add the cms id to filters
            const shopID = this.activeShop.id
            const filter = {
                key: 'shop',
                match: shopID,
            }
            this.defineFilterValue({ key: 'shop', value: filter })

            if (!this.includeGuests) {
                this.defineFilterValue({ key: 'hide_guests', value: { key: 'hide_guests', match: true } })
            } else {
                this.defineFilterValue({ key: 'hide_guests', value: { key: 'hide_guests', match: '', like: '', from: '', to: '', in: [] } })
            }

            this.fetchWishListsPaginated()
                .then(() => this.updateLoading(false))
                .catch(err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Wish List list could not be fetched.'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.updateLoading(false);

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                })
        },
        debouncedRefetch: _.debounce(function () { // function scope is needed here
            this.updateLoading(true)
            this.refetch()
        }, useSetupStore(pinia).debounce || 300),
        updateLoading(value) {
            this.wishListStore.updateLoading(value);
        },
        defineItemsPerPage(value) {
            this.wishListStore.defineItemsPerPage(value);
        },
        defineCurrentPage(value) {
            this.wishListStore.defineCurrentPage(value);
        },
        defineActiveColumns(value) {
            this.wishListStore.defineActiveColumns(value);
        },
        defineFilterValue(payload) {
            this.wishListStore.defineFilterValue(payload);
        },
        defineFilterVisibility(value) {
            this.wishListStore.defineFilterVisibility(value);
        },
        defineSort(payload) {
            this.wishListStore.defineSorting(payload);
        },
        fetchWishListsPaginated() {
            return this.wishListStore.fetchWishListsPaginated();
        },
        setClipboard(payload) {
            this.setupStore.setClipboard(payload);
        },
        removeFromClipboard(key) {
            this.setupStore.removeFromClipboard(key);
        },
        saveFilterVisibility(payload) {
            return this.setupStore.saveFilterVisibility(payload);
        },
        saveMiscSettings(payload) {
            return this.setupStore.saveMiscSettings(payload);
        },
    },
    mounted() {
        this.initialize()
    },
}
</script>

<style lang="sass" scoped>
.overwrite-wish-list-dialog::v-deep .el-dialog__body
    display: none

.table-top
    display: block
    .row
        display: flex
        justify-content: space-between
    .transfer
        margin-top: .5rem
.error
    padding: 20px
</style>
